export default __webpack_public_path__ + "static/media/arrow-right.414b9f82.svg";